import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const ProgressChartContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'simple',
})<{ simple?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ simple }) => (simple ? '0' : '24px')};
`

export const HeaderContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
`

export const Header = styled(Typography)`
  ${typography.up1.regularSerif}
  align-items: center;
  display: flex;
  min-width: max-content;
`

export const Actions = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'shouldSpaceBetween',
})<{ shouldSpaceBetween?: boolean }>`
  display: flex;
  justify-content: ${({ shouldSpaceBetween }) =>
    shouldSpaceBetween ? 'space-between' : 'flex-end'};
  gap: 16px;
  width: 100%;
`

export const ChartContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'simple',
})<{ simple?: boolean }>`
  background-color: ${({ simple }) =>
    simple ? 'none' : colors.background.secondaryBackground};
  height: ${({ simple }) => (simple ? 'auto' : '650px')};
  padding: ${({ simple }) => (simple ? '0' : '20px')};
  width: 100%;
`

export const Spacer = styled.div`
  display: inline-block;
  margin-left: 50px;
`

export const CalculationTypeChip = styled(Box)<{
  variant?: 'completed' | 'unassigned' | 'informational'
}>`
  align-items: center;
  background-color: #e5f2ff;
  border-radius: 4px;
  color: ${colors.info.dark};
  display: flex;
  gap: 6px;
  padding: 10px 6px;
  width: 275px;

  ${typography.baseline.semiBoldSans};
`

export const DuplicateDateChip = styled(Box)`
  align-items: center;
  background-color: ${colors.warning.light};
  border-radius: 4px;
  color: ${colors.warning.main};
  display: flex;
  gap: 12px;
  padding: 6px 16px;

  ${typography.baseline.semiBoldSans};
`
export const ChartTitle = styled(Typography)`
  ${typography.up1.regularSerif}
  font-family: Merriweather;
  margin-bottom: 25px;
`
